module.exports = __webpack_public_path__ + "img/OMART-footer-desktop.5e890080.svg";